import request from './request';
/**
 *  x3保养概况
 */
export function getWorkOrderX3Overview(params) {
    return request('/stat/work-order/x3/overview', {
        method: 'POST',
        params,
    });
}

/**
 * 接车情况-视图
 */
export function getVehicleView(params) {
    return request('/stat/work-order/x3/vehicle/view', {
        method: 'POST',
        params,
    });
}
/**
 * 接车情况-列表
 */
export function getVehicleList(params) {
    return request('/stat/work-order/x3/vehicle/list', {
        method: 'POST',
        params,
    });
}

/**
 * 接车情况-列表导出
 */
export function vehicleListExport(params) {
    return request('/stat/work-order/x3/vehicle/list-export', {
        method: 'POST',
        params,
    });
}

/**
 * 检测情况-视图
 */
export function getCheckView(params) {
    return request('/stat/work-order/x3/check/view', {
        method: 'POST',
        params,
    });
}
/**
 * 检测情况-列表
 */
export function getCheckList(params) {
    return request('/stat/work-order/x3/check/list', {
        method: 'POST',
        params,
    });
}

/**
 * 检测情况-列表导出
 */
export function checkListExport(params) {
    return request('/stat/work-order/x3/check/list-export', {
        method: 'POST',
        params,
    });
}
/**
 * 检测情况-检测模板列表
 */
export function getCheckTemplateList(params) {
    return request('/stat/work-order/x3/check/item-list', {
        method: 'POST',
        params,
    });
}
/**
 * 检测情况-检测模板列表导出
 */
export function checkTemplateListExport(params) {
    return request('/stat/work-order/x3/check/item-list-export', {
        method: 'POST',
        params,
    });
}
/**
 * 检测情况-检测项列表
 */
export function getCheckItemList(params) {
    return request('/stat/work-order/x3/check/point-list', {
        method: 'POST',
        params,
    });
}


/**
 * 查出问题情况-视图
 */
export function getProblemView(params) {
    return request('/stat/work-order/x3/problem/view', {
        method: 'POST',
        params,
    });
}
/**
 * 查出问题情况-列表
 */
export function getProblemList(params) {
    return request('/stat/work-order/x3/problem/list', {
        method: 'POST',
        params,
    });
}

/**
 * 查出问题情况-列表导出
 */
export function problemListExport(params) {
    return request('/stat/work-order/x3/problem/list-export', {
        method: 'POST',
        params,
    });
}


/**
 * 发布报告情况-视图
 */
export function getReportView(params) {
    return request('/stat/work-order/x3/report/view', {
        method: 'POST',
        params,
    });
}
/**
 * 发布报告情况-列表
 */
export function getReportList(params) {
    return request('/stat/work-order/x3/report/list', {
        method: 'POST',
        params,
    });
}

/**
 * 发布报告情况-列表导出
 */
export function reportListExport(params) {
    return request('/stat/work-order/x3/report/list-export', {
        method: 'POST',
        params,
    });
}


/**
 * 检测报告短信发送情况-视图
 */
export function getCheckSmsView(params) {
    return request('/stat/work-order/x3/check-sms/view', {
        method: 'POST',
        params,
    });
}
/**
 * 检测报告短信发送情况-列表
 */
export function getCheckSmsList(params) {
    return request('/stat/work-order/x3/check-sms/list', {
        method: 'POST',
        params,
    });
}

/**
 * 检测报告短信发送情况-列表导出
 */
export function checkSmsExport(params) {
    return request('/stat/work-order/x3/check-sms/list-export', {
        method: 'POST',
        params,
    });
}


/**
 * 施工报告短信发送情况-视图
 */
export function getConstructionSmsView(params) {
    return request('/stat/work-order/x3/construction-sms/view', {
        method: 'POST',
        params,
    });
}
/**
 * 施工报告短信发送情况-列表
 */
export function getConstructionSmsList(params) {
    return request('/stat/work-order/x3/construction-sms/list', {
        method: 'POST',
        params,
    });
}

/**
 * 施工报告短信发送情况-列表导出
 */
export function constructionSmsExport(params) {
    return request('/stat/work-order/x3/construction-sms/list-export', {
        method: 'POST',
        params,
    });
}


/**
 * 推荐服务项目情况-视图
 */
export function getRecommendItemView(params) {
    return request('/stat/work-order/x3/recommend-item/view', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-列表
 */
export function getRecommendItemList(params) {
    return request('/stat/work-order/x3/recommend-item/list', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-列表导出
 */
export function recommendItemExport(params) {
    return request('/stat/work-order/x3/recommend-item/list-export', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-数量列表
 */
export function getRecommendItemNumList(params) {
    return request('/stat/work-order/x3/recommend-item/num-list', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-数量列表导出
 */
export function recommendItemNumListExport(params) {
    return request('/stat/work-order/x3/recommend-item/num-list-export', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-转化率列表
 */
export function getRecommendItemConvertList(params) {
    return request('/stat/work-order/x3/recommend-item/convert-list', {
        method: 'POST',
        params,
    });
}
/**
 *推荐服务项目情况-转化率列表导出
 */
export function recommendItemConvertListExport(params) {
    return request('/stat/work-order/x3/recommend-item/convert-list-export', {
        method: 'POST',
        params,
    });
}

/**
 * 保养计划制定情况-视图
 */
export function getMaintenancePlanView(params) {
    return request('/stat/work-order/x3/maintenance-plan/view', {
        method: 'POST',
        params,
    });
}
/**
 *保养计划制定情况-列表
 */
export function getMaintenancePlanList(params) {
    return request('/stat/work-order/x3/maintenance-plan/list', {
        method: 'POST',
        params,
    });
}
/**
 *保养计划制定情况-列表导出
 */
export function maintenancePlanExport(params) {
    return request('/stat/work-order/x3/maintenance-plan/list-export', {
        method: 'POST',
        params,
    });
}
/**
 * 查询是否购买第三方服务
 */
export function getExternalServiceFlag() {
    return request('/work-order/external-service-flag', {
        method: 'GET',
    });
}
/**
 * 员工表现-服务顾问报表1---列表查询
 */
export function getEmployeeAdviserOne(params) {
    return request('/stat/work-order/x3/employee/adviser/overview-one', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-服务顾问报表1---列表导出
 */
export function exportEmployeeAdviserExportOne(params) {
    return request('/stat/work-order/x3/employee/adviser/overview-one/export', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-服务顾问报表2---列表查询
 */
export function getEmployeeAdviserTwo(params) {
    return request('/stat/work-order/x3/employee/adviser/overview-two', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-服务顾问报表2----列表导出
 */
export function exportEmployeeAdviserExportTwo(params) {
    return request('/stat/work-order/x3/employee/adviser/overview-two/export', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-施工人员报表1---列表查询
 */
export function getEmployeeConstructorOne(params) {
    return request('/stat/work-order/x3/employee/constructor/overview-one', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-施工人员报表1---列表导出
 */
export function exportEmployeeConstructorExportOne(params) {
    return request('/stat/work-order/x3/employee/constructor/overview-one/export', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-施工人员报表2---列表查询
 */
export function getEmployeeConstructorTwo(params) {
    return request('/stat/work-order/x3/employee/constructor/overview-two', {
        method: 'POST',
        params,
    });
}
/**
 * 员工表现-施工人员报表2----列表导出
 */
export function exportEmployeeConstructorExportTwo(params) {
    return request('/stat/work-order/x3/employee/constructor/overview-two/export', {
        method: 'POST',
        params,
    });
}
/**
 * 预检报告短信发送情况-视图
 */
export function getPreCheckSmsView(params) {
    return request('/stat/work-order/x3/pre-check-sms/view', {
        method: 'POST',
        params,
    });
}
/**
 * 预检报告短信发送情况-列表
 */
export function getPreCheckSmsList(params) {
    return request('/stat/work-order/x3/pre-check-sms/list', {
        method: 'POST',
        params,
    });
}

/**
 * 预检报告短信发送情况-列表导出
 */
export function preCheckSmsExport(params) {
    return request('/stat/work-order/x3/pre-check-sms/list-export', {
        method: 'POST',
        params,
    });
}
